import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Table, Pagination, Button } from 'components';
import Classified from './classified/classified';
import Banner from './banner/banner';
import { ClinicIcon, ClasificadosIcon, BannersIcon } from 'assets/icons';
import { AdvertisementService } from 'services';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const TABS = {
	CLASSIFIED: 1,
	BANNERS: 2,
}

class Advertisement extends React.Component<Props> {

	state = {
		tab: TABS.CLASSIFIED,
		document_types: [],
		phonecodes: [],
		specialities: [],
		states: [],
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Gestión de publicidad',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async () => {
		
	}

	setTab = (tab: number) => {
		this.setState({
			tab
		});
	}
	
	render() {
		return (
			<div id="admin-register">
				{
					this.state.tab == TABS.CLASSIFIED && (
						<Classified
							history={ this.props.history }
							document_types={ this.state.document_types }
							phonecodes={ this.state.phonecodes }
							tabs={<Tabs tab={this.state.tab} setTab={this.setTab} />}
						/>
					)
				}

				{
					this.state.tab == TABS.BANNERS && (
						<Banner
							history={ this.props.history }
							document_types={ this.state.document_types }
							phonecodes={ this.state.phonecodes }
							specialities={ this.state.specialities }
							states={ this.state.states }
							tabs={<Tabs tab={this.state.tab} setTab={this.setTab} />}
						/>
					)
				}
			</div>
		)
	}
}

interface TabsProps {
	setTab: (tab: number) => void;
	tab: number;
}

const Tabs = ({ setTab, tab }: TabsProps) => (
	<div className="row-tabs-2">
		<Button onClick={() => setTab(TABS.CLASSIFIED)} className={tab === TABS.CLASSIFIED ? 'active' : ''}>
			<div>
				<img src={ClasificadosIcon} alt="icon" />
			</div>
			<p>Clasificados</p>
		</Button>
		<Button onClick={() => setTab(TABS.BANNERS)} className={tab === TABS.BANNERS ? 'active' : ''}>
			<div>
				<img src={BannersIcon} alt="icon" />
			</div>
			<p>Banners</p>
		</Button>
	</div>
)

export default connect()(Advertisement);